import { render, staticRenderFns } from "./BuilderErase.vue?vue&type=template&id=605071d4&scoped=true&"
import script from "./BuilderErase.vue?vue&type=script&lang=js&"
export * from "./BuilderErase.vue?vue&type=script&lang=js&"
import style0 from "./BuilderErase.vue?vue&type=style&index=0&id=605071d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605071d4",
  null
  
)

export default component.exports